import React from "react"

import ContrastChip from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/ContrastChip"
import { CustomValidationRenderValue } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionContainer"
import {
	VALIDATION_TYPE_RESPONSIBLE_ATTENDANT_CONDITION_TO_NAME,
	ResponsibleAttendantConditionType
} from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor/ClientResponsibleAttendantInput"
import { colors } from "@/styles/colors"

type AttendantUser = { id: number, name: string }

const ClientResponsibleAttendantContainer: CustomValidationRenderValue = {
	firstItem: {
		render: () => (
			<ContrastChip
				title="Atendente responsável"
				backgroundColor={colors.blue[200]}
			/>
		)
	},
	comparisonItem: {
		render: ({ validation }) => {
			const typeName = VALIDATION_TYPE_RESPONSIBLE_ATTENDANT_CONDITION_TO_NAME[validation.type as ResponsibleAttendantConditionType] ?? validation.type
			return (
				<ContrastChip
					title={String(typeName)}
					backgroundColor={colors.blue[200]}
				/>
			)
		}
	},
	secondItem: {
		render: ({ validation, constructionResources }) => {
			const users: AttendantUser[] = constructionResources.conditionOptions.users ?? []
			const user = users.find((attendant) => attendant.id === validation.second_param)

			return (
				<ContrastChip
					title={user?.name ?? "??"}
					backgroundColor={colors.blue[400]}
				/>
			)
		}
	}
}

export default ClientResponsibleAttendantContainer
